import type { Platform } from "../types";
import { shopwareAdapter } from "./shopware";
import { trayAdapter } from "./tray";
import type { PlatformAdapter } from "./types";
import { vtexAdapter } from "./vtex";

const ADAPTERS: Record<Exclude<Platform, "unknown">, PlatformAdapter> = {
  vtex: vtexAdapter,
  tray: trayAdapter,
  shopware: shopwareAdapter,
};

function detectPlatform(): { adapter: PlatformAdapter; platform: Platform } | null {
  const entry = Object.entries(ADAPTERS).find(([, adapter]) => adapter.isCurrentPlatform());
  return entry ? { adapter: entry[1], platform: entry[0] as Platform } : null;
}

export interface ResolvedPlatform {
  adapter: PlatformAdapter;
  platform: Platform;
}

export function resolveAdapter(configured: Platform): ResolvedPlatform | null {
  if (configured !== "unknown") return { adapter: ADAPTERS[configured], platform: configured };
  return detectPlatform();
}

export type { PlatformAdapter };
